// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 620 ? "pdfjsWorker" : chunkId) + "." + {"511":"b171cc79","620":"0f296b54"}[chunkId] + ".chunk.js";
};